import React from "react";

import { LanguageListingProvider } from "../context/LanguageListingProvider";
import { LanguagesListing } from "./LanguagesListing";

export const LanguageDashboard: React.FC = () => {
    return (
        <LanguageListingProvider>
            <LanguagesListing />
        </LanguageListingProvider>
    );
};
